import React from 'react';
import './Poll.scss';

function Q2AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      AD symptoms negatively impact overall patient school-work performance and productivity. On
      average, patients have been shown to miss 2.5 days of school or work per year. While in school
      or work, their concentration is affected by symptoms 9% of the time while in flare.
    </p>
  );
}

export default Q2AnswerCopy;
